module.exports = __webpack_public_path__ + "img/change.5e69487f.svg";